const colors = [
    '#76FFA7',
    '#F471A6',
    '#76A4FF',
    '#A873FF',
    '#3797F7',
    '#F471A6',
    '#6C4CDE',
    '#F37A7A',
    '#76D5FF',
    '#8FFF7B',
    '#FFD576',
    '#3979FA',
];
/**
 * The given ID will assign a pseudorandom value to the color assignment,
 * This way, the same ID will always result in the same color assignment
 */
const getSeededColor = (seed) => {
    /** use seed to get a random value */
    const encoded = seed.split('').reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    const index = encoded % colors.length;
    return colors[index];
};
/**
 * Mutate the brightness of a given hex color value
 */
const mutateColorBrightness = (color = '#000000', percentage) => {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    const newR = Math.min(255, Math.max(0, Math.floor(r * (1 + percentage / 100))));
    const newG = Math.min(255, Math.max(0, Math.floor(g * (1 + percentage / 100))));
    const newB = Math.min(255, Math.max(0, Math.floor(b * (1 + percentage / 100))));
    return `#${newR.toString(16).padStart(2, '0')}`
        + `${newG.toString(16).padStart(2, '0')}`
        + `${newB.toString(16).padStart(2, '0')}`;
};
const hexAlphaTransform = (
/** Hex value without alpha */
hex, 
/** Value between 0 and 1 */
alpha) => {
    const hexValue = hex.replace('#', '');
    if (hexValue.length !== 6) {
        throw new Error('Hex value must be 6 characters long');
    }
    const hexAlpha = (percentage) => Math.floor(percentage * 255)
        .toString(16)
        .padStart(2, '0');
    return `#${hexValue}${hexAlpha(alpha)}`;
};

export { getSeededColor, hexAlphaTransform, mutateColorBrightness };
